import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["name"];
import isEmpty from 'lodash/isEmpty';
import snakeCase from 'lodash/snakeCase';
import * as LocaleUtil from './locales';
var SHEETS_COPY_STEPS = {
  COPY_ROLE_PERMISSIONS: 'COPY_ROLE_PERMISSIONS'
};
export var parseSheetsCopyInfo = function parseSheetsCopyInfo(copyInfo) {
  var _stepDetail, _stepDetail$data;
  if (isEmpty(copyInfo)) return copyInfo;
  if ((copyInfo === null || copyInfo === void 0 ? void 0 : copyInfo.currentStep) !== SHEETS_COPY_STEPS.COPY_ROLE_PERMISSIONS) return copyInfo;
  if (isEmpty(copyInfo === null || copyInfo === void 0 ? void 0 : copyInfo.stepDetails)) return copyInfo;
  var data = _extends({}, copyInfo);
  var stepDetail;
  var stepDetailIndex = -1;
  if (Array.isArray(data.stepDetails)) {
    stepDetailIndex = data.stepDetails.findIndex(function (_ref) {
      var name = _ref.name;
      return name === SHEETS_COPY_STEPS.COPY_ROLE_PERMISSIONS;
    });
    if (stepDetailIndex >= 0) stepDetail = data.stepDetails[stepDetailIndex];
  } else {
    stepDetail = data.stepDetails;
  }
  var failRoles = (_stepDetail = stepDetail) === null || _stepDetail === void 0 ? void 0 : (_stepDetail$data = _stepDetail.data) === null || _stepDetail$data === void 0 ? void 0 : _stepDetail$data.failRoles;
  if (Array.isArray(failRoles) && failRoles.length > 0 && data.stepDetails) {
    var localizedRoles = failRoles.map(function (_ref2) {
      var name = _ref2.name,
        rest = _objectWithoutProperties(_ref2, _excluded);
      return _extends({}, rest, {
        name: LocaleUtil.translate("userRoles.".concat(snakeCase(name)), name)
      });
    });
    if (stepDetailIndex >= 0) {
      data.stepDetails[stepDetailIndex].data.failRoles = localizedRoles;
    } else {
      var _data$stepDetails;
      if ('data' in data.stepDetails && (_data$stepDetails = data.stepDetails) !== null && _data$stepDetails !== void 0 && _data$stepDetails.data) {
        data.stepDetails.data.failRoles = localizedRoles;
      }
    }
  }
  return data;
};